<form [formGroup]="conditionForm" (ngSubmit)="onClickSearch()">
  <mat-card class="cur-card">
    <mat-card-header>
      <mat-card-title>検索条件</mat-card-title>
      <mat-icon></mat-icon>
    </mat-card-header>
    <mat-card-content>
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="input-form-date" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>口座振替日</mat-label>
          <input matInput
            formControlName="kouzaFrikaeDate"
            [matDatepicker]="kouzaFrikaeDate"
          />
          <mat-datepicker-toggle matSuffix [for]="kouzaFrikaeDate"></mat-datepicker-toggle>
          <mat-datepicker #kouzaFrikaeDate [startAt]="kouzaFrikaeDateStDate"></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-form-date" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>依頼返却締切日</mat-label>
          <input matInput
            formControlName="reqReturnDeadline"
            [matDatepicker]="reqReturnDeadline"
          />
          <mat-datepicker-toggle matSuffix [for]="reqReturnDeadline"></mat-datepicker-toggle>
          <mat-datepicker #reqReturnDeadline [startAt]="reqReturnDeadlineStDate" ></mat-datepicker>
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="input-form-date" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>依頼返却金融機関コード</mat-label>
          <input matInput
            formControlName="reqretBankfcCode"
            autocomplete="off"
            (blur)="searchBankNm()"
          />
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-form-field appearance="outline" class="input-form-date" fxFlex="30" fxFlex.lt-md="100">
          <mat-label>依頼返却金融機関名</mat-label>
          <input matInput
            formControlName="reqretBankfcMei"
            class="font-color-display-only"
            readonly
          />
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-card-actions style="margin-left: 40px;">
          <mat-checkbox
            formControlName="cbOutputfinishReqretHyoji"
          >出力済依頼返却表示</mat-checkbox>
        </mat-card-actions>
      </div>

      <div fxLayout="row wrap" fxLayoutAlign="end center">
        <mat-card-actions class="btn_area_right">
          <button type="submit" mat-raised-button
            color="primary"
            class="btn btnSearch"
            [disabled]="disabledBtnSearch()"
          >検索</button>
        </mat-card-actions>
        <mat-card-actions class="btn_area_right">
          <button type="button" mat-raised-button
            color="primary"
            class="btn btnClear"
            (click)="onClickClear()"
          >クリア</button>
        </mat-card-actions>
      </div>
    </mat-card-content>
  </mat-card>
</form>
      
  
  